export default __webpack_public_path__ + "static/media/casper02.4fda688a.png";